<div class="csv-dialog-container">
  <div class="csv-dialog-header">
    <div class="csv-dialog-icon">
      <mat-icon>warning</mat-icon>
    </div>
    <h1 mat-dialog-title class="csv-dialog-title">
      {{title}}
    </h1>
  </div>

  <div mat-dialog-content class="csv-dialog-content">
    <p class="csv-dialog-message">{{message}}</p>
  </div>

  <div class="csv-dialog-actions" mat-dialog-actions>
    <button class="csv-dialog-btn csv-dialog-btn-secondary" mat-button (click)="onDismiss()">
      <span>Cancel</span>
    </button>
    <button class="csv-dialog-btn csv-dialog-btn-primary" mat-raised-button color="primary" (click)="onConfirm()">
      <span>Proceed</span>
    </button>
  </div>
</div>

